import { atom } from "recoil";

export type ConfirmType = {
  visibleConfirm: boolean;
  handleConfirm: (() => void) | null;
  title: string;
  successText:  string;
  cancelText:  string;
};

export const confirmState = atom<ConfirmType>({
  key: "confirmState",
  default: {
    visibleConfirm: false,
    handleConfirm: null,
    title: "",
    successText: "",
    cancelText: "",
  },
});